var x_crud = function () { };
x_crud.prototype = {
	json: {
		save: function (url, data, callback, config) { //data, callback, url, form, disablenotify
			if (!config) { config = {}; }
			//xlog(url);
			var me = this,
				obj = {
					url: url || '/php/json/save.php',
					type: 'POST',
					dataType: 'json',
					data: data,
					async: (config.async === false ? false : true),
					success: function (response) {
						var newPk = response.pk || response.data || '';

						if (!me.check_failure(response)) {
							if (callback) {
								if (typeof callback == 'string') {
									if (typeof window[callback] === 'function') {
										window[callback](response.success, null, response.data);
										loadingbar.stop();
									} else {
										xlog(window[callback], 'ne funkcija');
										loadingbar.stop();
									}
								} else {
									callback(response.success, null, response.data);
									loadingbar.stop();
								}
							}
							return;
						}
						//debugger;
						if (response.msg === false) {
							if (!callback) {
								window.onbeforeunload = null;
								window.location.href = response.url || config.url || location.href;
								return;
							}
							config.disablenotify = true;
						}

						if (!callback && !config.disablenotify) {
							var msg = 'Sėkmingai išsaugota',
								title,
								type = 'success';
							if (response.msg === undefined) {

							} else if (typeof response.msg === 'string') {
								msg = response.msg;
								title = 'Išsaugota';
							} else {
								msg = response.msg.message || msg;
								title = response.msg.title || title;
								type = response.msg.type || type;
							}

							xdialog.notify.show(title, msg, type, function () {
								var href = response.url || config.url || location.href;
								window.onbeforeunload = null;
								window.location.href = href.replace('$pk', newPk);
							});

							return;
						}
						if (callback) {
							if (typeof callback == 'string') {
								if (typeof window[callback] === 'function') {
									window[callback](response.success, response.pk, response.data);
									loadingbar.stop();
								} else {
									xlog(window[callback], 'ne funkcija');
									loadingbar.stop();
								}
							} else {
								callback(response.success, response.pk, response.data);
								loadingbar.stop();
							}

							return;
						}

						loadingbar.stop();

						if (config.url) {
							window.open(config.url.replace('$pk', newPk), '_self');
							return;
						}

					},
					error: function (response) {
						loadingbar.stop();
						if (role.developer === true) {
							xdialog.notify.show('Klaida', response.responseText, 'danger');
							return;
						}

						xdialog.notify.show('Klaida', 'Įvyko klaida', 'danger');
					},
					beforeSend: function () {
						loadingbar.start();
					}
				};

			if (config.form && config.form.find('input[type=file]').length > 0) {
				var r = false,
					form = config.form;

				form.find("input[type='file']").each(function () {
					if ($(this).get(0).files.length === 0) {
						if (!$(this).hasClass('hidden-files-input')) {
							$(this).remove();
						}
					} else {
						r = true;
					}
				});

				if (r === true) {
					obj.data = new FormData(form[0]);
					obj.processData = false;
					obj.cache = false,
						obj.contentType = false;
				}
			}

			$.ajax(obj);
		},
		/*
		save:function(data, callback, url, form, disablenotify) {
			var me = this,
				obj = {
				url : data.url || url || '/php/json/save.php',
				type    : 'POST',
				dataType: 'json',
				data    : data.data,
				async   : (data.async === false ? false : true),
				success : function(response) {
					
					if (!me.check_failure(response)) {
						if (callback) {
							if (typeof callback == 'string'){
								if (typeof window[callback] === 'function'){
									window[callback](response.success, null, response.data);
									loadingbar.stop();
								} else {
									xlog(window[callback], 'ne funkcija');
									loadingbar.stop();
								}
							} else {
								callback(response.success, null, response.data);
								loadingbar.stop();
							}
						}
						return;
					}
					//debugger;
					if (response.msg === false){
						if (!callback){
							window.location.href = url || response.url || location.href;
							return;
						}
						disablenotify = true;
					}
					
					if (!callback && !disablenotify) {
						var msg = 'Sėkmingai išsaugota',
							title,
							type = 'success';
				
						if (response.msg === undefined){
							
						} else if (typeof response.msg === 'string'){
							msg = response.msg;
							title = 'Išsaugota';
						} else {
							msg = response.msg.message || msg;
							title = response.msg.title || title;
							type = response.msg.type || type; 
						}
						
						xdialog.notify.show(title, msg, type, function(){
							window.location.href = url || response.url || location.href;
						});
						
						return;
					}
					if (callback) {
						if (typeof callback == 'string'){
							if (typeof window[callback] === 'function'){
								window[callback](response.success, response.pk, response.data);
								loadingbar.stop();
							} else {
								xlog(window[callback], 'ne funkcija');
								loadingbar.stop();
							}
						} else {
							callback(response.success, response.pk, response.data);
							loadingbar.stop();
						}
						
						return;
					}
					
					if (url){
						window.open(url, '_self');
						return;
					}
				
				},
				error: function(response) {
					loadingbar.stop();
					if (role.developer === true){
						xdialog.notify.show('Klaida', response.responseText, 'danger');
						return;
					}
					
					xdialog.notify.show('Klaida', 'Įvyko klaida', 'danger');
				},
				beforeSend:function(){
					loadingbar.start();
				}
			};
			
			if (form && form.find('input[type=file]').length > 0){
				var r = false;
				form.find("input[type='file']").each(function(){
					if ($(this).get(0).files.length === 0) {
						$(this).remove();
					} else {
						r = true;
					}
				});
				if (r === true){
					obj.data = new FormData(form[0]);
					obj.processData = false;
					obj.cache = false,
					obj.contentType = false;
				}
			}
			
			$.ajax(obj);
		},
		*/
		/**
		 * 
		 * @param {Object} config `xdialog.question` config (type, title, text, ...)
		 * @param {String} url POST URL
		 * @param {Object|String} data POST data
		 * @param {String} redirectUrl URL kur kreipti po delete
		 * @param {String|Function} callback 
		 */
		del: function (config, { url, data }, redirectUrl, callback) {
			var me = this;
			xdialog.question.show(config, function (answer) {
				if (answer == true) {
					me.save(url, data, callback, {
						url: redirectUrl
					});
				}
			});
		},
		check_failure: function (response) {
			if (response.success === false) {
				var msg, title, type = 'danger';

				if (typeof response.msg === 'string') {
					msg = response.msg;
					title = null;
				} else {
					msg = response.msg.message;
					title = response.msg.title;
					type = response.msg.type || type;
				}

				//xerror.sql(response.msg, response.errornr, response.erroruser);
				xdialog.notify.show(title, msg, type);
				loadingbar.stop();
				return false;
			}

			return true;
		},
		exec: function (proc, url, blank = false) {
			var me = this;
			$.ajax({
				url: '/php/json/proc.php',
				type: 'POST',
				async: false,
				dataType: 'json',
				data: {
					query: proc
				},
				success: function (response) {
					if (!me.check_failure(response)) {
						err = response.msg;
						return;
					}

					if (url) {
						url = url.replace('$pk', response.data);
						// xhelper.content.load(url);
						if (blank) {
							window.open(url);
							location.reload();
						} else {
							window.location = url;
						}
					} else {
						xdialog.notify.show('Baigta', 'Procedūra sėkmingai įvykdyta', 'success');
					}

					loadingbar.stop();
				},
				error: function () {
					xdialog.notify.show('Klaida', 'Įvyko klaida', 'danger');
					loadingbar.stop();
				},
				beforeSend: function () {//before send, return false <--atsaukia uzklausa
					loadingbar.start();
					return true;
				}
			});
		},
		load: function (url, data, callback, async) {
			var me = this;
			$.ajax({
				url: url,
				type: 'POST',
				async: (async === false ? false : true),
				dataType: 'json',
				data: data,
				success: function (response) {
					if (!me.check_failure(response)) {
						err = response.msg;
						return;
					}

					callback(response, response.data);
					loadingbar.stop();
				},
				/*complete:function(){
					
				},*/
				error: function () {
					xdialog.notify.show('Klaida', 'Įvyko klaida', 'danger');
					loadingbar.stop();
				},
				beforeSend: function () {//before send, return false <--atsaukia uzklausa
					return true;
				}
			});
		},
		load_file: function (url, data, callback, async) {
			var me = this;
			$.ajax({
				url: url,
				type: 'POST',
				async: (async === false ? false : true),
				dataType: 'json',
				data: data,
				processData: false,
				contentType: false,
				success: function (response) {
					if (!me.check_failure(response)) {
						err = response.msg;
						return;
					}

					callback(response, response.data);
					loadingbar.stop();
				},
				/*complete:function(){
					
				},*/
				error: function () {
					xdialog.notify.show('Klaida', 'Įvyko klaida', 'danger');
					loadingbar.stop();
				},
				beforeSend: function () {//before send, return false <--atsaukia uzklausa
					return true;
				}
			});
		},
		send: function (url, data, callback) { //siuncia i viena puse, responso nera
			var me = this;
			$.ajax({
				url: url,
				type: 'POST',
				dataType: 'json',
				data: data,
				success: function (response) {
					callback();
				},
				error: function () {

				}
			});
		}
	},
	load: function (url, data, callback, async) {
		var me = this;
		$.ajax({
			url: url,
			type: 'POST',
			async: (async === false ? false : true),
			//dataType: 'json',
			data: data,
			success: function (response) {
				callback(response);
				loadingbar.stop();
			},
			error: function () {
				xdialog.notify.show('Klaida', 'Įvyko klaida', 'danger');
				loadingbar.stop();
			},
			beforeSend: function () {//before send, return false <--atsaukia uzklausa
				return true;
			}
		});
	},
	post: function (url, data, callback, async) {
		this.load(url, data, callback, async); //realiai tas pats kas load
	}
};

var xcrud = new x_crud();